
import state from './moduleResourceHubState.js';
import mutations from './moduleResourceHubMutations.js';
import actions from './moduleResourceHubActions.js';
import getters from './moduleResourceHubGetters.js';

export default {
  namespaced: true,
  state: state,
  mutations: mutations,
  actions: actions,
  getters: getters,
};
